import React from 'react';
import { observer } from 'mobx-react';
import {
  Button, IconType,
} from '@routific/hive';
import usePermissions, { Features } from '../../../../../permissions/usePermissions';
import ComponentNames from '../../../../../permissions/constants/componentNames';
import { RouteProps } from '../../../../../store/mst/utils/getRoutesProps';
import ActionDropdown from '../../../../shared/ActionDropdown';
import getRouteActionsMenuItems from './getRouteActionsMenuItems';

interface RouteActionsButtonProps {
  routeProps: RouteProps;
  overrideLoading: boolean;
  projectId?: number;
}

const RouteActionsButton: React.FC<RouteActionsButtonProps> = ({
  routeProps,
  overrideLoading,
  projectId,
}) => {
  const {
    canEditRoutes,
    canDeleteRoutes,
    canCreateOptimization,
    canAssignStopsToRoutes,
    canCreateRoutes,
  } = usePermissions(Features.Routes, ComponentNames.RouteDetailsPanel);

  const {
    canDownloadSolution,
  } = usePermissions(Features.Routes, ComponentNames.DownloadCSV);

  const triggerButton = <Button icon={IconType.More} size="small" data-testid="route-actions-trigger-btn" />;

  const menuItems = getRouteActionsMenuItems({
    routeProps,
    overrideLoading,
    projectId,
    permissions: {
      canEditRoutes: !!canEditRoutes,
      canDeleteRoutes: !!canDeleteRoutes,
      canCreateOptimization: !!canCreateOptimization,
      canAssignStopsToRoutes: !!canAssignStopsToRoutes,
      canCreateRoutes: !!canCreateRoutes,
      canDownloadSolution: !!canDownloadSolution,
    },
  });

  return (
    <ActionDropdown
      triggerButton={triggerButton}
      menuItems={menuItems}
    />
  );
};

export default observer(RouteActionsButton);
